/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { MOVIE_RATING_VALUES, type MovieRatingValueType } from '@repo/config';
import { z } from 'zod';

export { MOVIE_RATING_VALUES, type MovieRatingValueType };

export const movieRatingValueSchema = z.enum(MOVIE_RATING_VALUES);
